import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import './App.css';
import AppRoutes from "./AppRoutes";
import Content from "../common/Content";
import Header from "../common/Header";
import DataService from '../services/DataService';
import { AuthContextProvider } from '../services/AuthService';
import { EnumContextProvider } from '../services/EnumService';
import { NotificationContextProvider } from '../services/NotificationService';
import { ThemeContextProvider } from '../services/ThemeService';

const App = (props) => {

  console.log("================================== App ======================================");

  // Init Data Service
  DataService.Init();

  // Build App
  let view = (
    <React.Fragment>
      <ThemeContextProvider>
        <AuthContextProvider>
          <NotificationContextProvider>
            <EnumContextProvider>
              <Router basename="/">
                <Header></Header>
                <Content>
                  <AppRoutes />
                </Content>
              </Router>
            </EnumContextProvider>
          </NotificationContextProvider>
        </AuthContextProvider>
      </ThemeContextProvider>
    </React.Fragment>
  )

  // Return View
  return view
}

export default App;
